/* eslint-disable max-lines */
import { computed } from 'mobx';
import { Trans } from 'react-i18next';
import { ApplicationDetailsPage } from 'src/pages/ApplicationDetailsPage/ApplicationDetailsPage';
import { ApplicationsCreateChooseOfferPage } from 'src/pages/ApplicationsCreateChooseOfferPage/ApplicationsCreateChooseOfferPage';
import { ApplicationsCreatePage } from 'src/pages/ApplicationsCreatePage/ApplicationsCreatePage';
import { ApplicationsPage } from 'src/pages/ApplicationsPage/ApplicationsPage';
import { RouteDefinition } from 'src/stores/RouterStore/RouterStore.types';
import { filterMenuItems } from 'src/stores/RouterStore/utils';

export class RouterStoreClass {
    @computed get routes(): RouteDefinition[] {
        return [
            {
                key: 'applications',
                path: '/applications',
                menuTitle: () => (
                    <Trans i18nKey="App.Header.Menu.Applications" />
                ),
                Component: ApplicationsPage,
            },
            {
                key: 'application-create',
                path: '/applications/create',
                Component: ApplicationsCreatePage,
            },
            {
                key: 'application-create-choose-offer',
                path: '/applications/:taskId/choose-offers',
                Component: ApplicationsCreateChooseOfferPage,
            },
            {
                key: 'application-details',
                path: '/applications/:id',
                Component: ApplicationDetailsPage,
            },
        ];
    }

    @computed get menuItems(): RouteDefinition[] {
        return filterMenuItems(this.routes);
    }
}

export const RouterStore = new RouterStoreClass();
